module.exports = __webpack_public_path__ + "img/image-23.39bf95b3.jpg";